import { Injectable } from '@angular/core';
import { Vaa } from '../models/Vaa';
import { Observable, throwError } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { DataService } from './data.service';
import { ToastComponent } from '../shared/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class VaaService {
  vaaDoc: AngularFirestoreDocument<Vaa>;
  constructor(private firestore: AngularFirestore,public dataService: DataService,public toastComponent: ToastComponent,) {this.toastComponent = toastComponent }
  vaa:Vaa = {
  }
  getVaa(id:string): Observable<Vaa>
  {
    return this.firestore.collection("Vaa").doc<VaaService>(id).get().pipe(take(1),
      map(queryResult => {
        if(queryResult.exists){
          const data = queryResult.data() as Vaa;
          const id = queryResult.id;
          this.dataService.vaa = data;
          return {id, ...data};
        }
        else{
          return null;
        }
      }));
  }
  //Voorbeeld van realtime veranderingen
  streamVaa(id: string): Observable<Vaa> {
    return this.firestore.collection('Vaa').doc<Vaa>(id).snapshotChanges().pipe(
      map(changes => {
        if (changes.payload.exists) {
          return { id, ...changes.payload.data() };
        } else {
          throwError(new Error(`Vaa with id ${id} does not exist or has been deleted`));
        }
      }));
  }
  async addVaa()
  {
    let vaaId = '';
    await this.firestore.collection("Vaa").add(this.vaa).then(function(docRef){
      vaaId = docRef.id
    })
    return vaaId;
  }

  //Deze methode wordt alleen gebruikt wanneer de priveAdmin een nieuwe onderneming aanmaakt.
  updateNaToevoegen(id: string, ondernemingId:string, ondernemingNaam:string)
  {
    this.vaa.ondernemingId = ondernemingId;
    this.vaa.ondernemingNaam = ondernemingNaam;
    this.vaa.id = id;
    this.updateVaa(this.vaa);
  }
  
  async updateVaa(vaa: Vaa) {
    try {
      this.vaaDoc = this.firestore.doc(`Vaa/${vaa.id}`);
      
      // Wacht op resultaat van de update operation, en gooit een error indien er een optreed.
      await this.vaaDoc.update(vaa);
      this.dataService.vaa = vaa;
      this.toastComponent.showSuccess();
      // De catch hieronder kan deze dan opvangen
    } catch (err) {
      console.log(err);
    }
  }
  deleteVaa(id: string){
    this.vaaDoc = this.firestore.doc(`Vaa/${id}`);
    this.vaaDoc.delete();
  }

}
